import assetService from '../services/asset.service';
import billService from '../services/bill.service';
import paymentService from '../services/payment.service';
import creditPaymentService from '../services/creditPayment.service';
import assetSaleService from '../services/assetSale.service';
import accountService from '../services/account.service';
import contractService from '../services/contract.service';
import debtService from '../services/debt.service';
import creditService from '../services/credit.service';
import contactService from '../services/contact.service';

export const OBJECT_SERVICE_CONFIG = {
	escritura: {
		service: assetService,
		fieldName: 'asset',
		label: 'Activo',
		displayField: 'name',
	},
	bill: {
		service: billService,
		fieldName: 'bill',
		label: 'Gasto',
		displayField: 'name',
	},
	payment: {
		service: paymentService,
		fieldName: 'payment',
		label: 'Pago',
		displayField: 'customId',
	},
	creditPayment: {
		service: creditPaymentService,
		fieldName: 'creditPayment',
		label: 'Pago de Crédito',
		displayField: 'customId',
	},
	assetSale: {
		service: assetSaleService,
		fieldName: 'assetSale',
		label: 'Venta de Activo',
		displayField: 'customId',
	},
	account: {
		service: accountService,
		fieldName: 'account',
		label: 'Cuenta',
		displayField: 'name',
	},
	contract: {
		service: contractService,
		fieldName: 'contract',
		label: 'Contrato',
		displayField: 'customId',
	},
	debt: {
		service: debtService,
		fieldName: 'debt',
		label: 'Deuda',
		displayField: 'customId',
	},
	credit: {
		service: creditService,
		fieldName: 'credit',
		label: 'Pasividad',
		displayField: 'customId',
	},
	contact: {
		service: contactService,
		fieldName: 'contact',
		label: 'Contacto',
		displayField: 'name',
	},
};

export const getObjectServiceConfig = (objType) => OBJECT_SERVICE_CONFIG[objType] || null;
